export default __webpack_public_path__ + "static/media/jenukallupeak.edcefffa.jpg";